import bluePlus from "./BluePlusCircle.svg";

import React from "react";

function BlueButton({ parentStyle, handler }) {
    return (
        <img
            onClick={handler}
            className={`${parentStyle}-date-period__blue-plus`}
            src={bluePlus}
            alt="bluePlus" />
    );
}

export default BlueButton;
